import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { typo } from '../../../assets/fonts/font';
import colorConfigs from '../../../configs/colorConfigs';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme, expanded }: { theme: any; expanded: boolean }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: expanded ? colorConfigs.primary : colorConfigs.transparent,
  '& .MuiAccordionSummary-root': {
  },
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
  ...theme.applyStyles('light', {
    backgroundColor:colorConfigs.primary,
    color:colorConfigs.tertiary,
    borderRadius: '8px 8px 8px 8px',
    borderStyle:'solid',
    borderWidth:2,
  }),
  '&.Mui-expanded': {
    borderRadius: '8px 8px 0 0',
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme, expanded }: { theme: any; expanded: boolean }) => ({
  padding: theme.spacing(2),
  borderTop: 'none',
  backgroundColor: expanded ? colorConfigs.secondary : colorConfigs.transparent,
}));

export default function CustomizedAccordions() {
  const [expanded, setExpanded] = React.useState<string | false>('panel1');

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Typography variant="h6" sx={{ ...typo.title, mb: 1 }}>
        Frequently Asked Questions
      </Typography>
      <Accordion
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
        theme={undefined}
        sx={{ borderRadius: '8px', overflow: 'hidden',mb:1 }}
      >
        <AccordionSummary
          expandIcon={<KeyboardArrowRightIcon style={{ color: colorConfigs.secondary }} />}
          aria-controls="panel1d-content"
          id="panel1d-header"
        >
          <Typography sx={{ ...typo.bodyContent, color: colorConfigs.secondary }}>I'm new here! How do I get started?</Typography>
        </AccordionSummary>
        <AccordionDetails
          theme={undefined}
          expanded={false}
          sx={{
            background:colorConfigs.quaternary,
            borderRadius: '0 0 8px 8px',
            boxShadow: 1,
            borderStyle:'solid',
            borderWidth:2,
            borderTop: 'none',
          }}
        >
          <Typography sx={typo.bodyContent}>To set up your wallet, link your preferred credit card for fuss-free payments, or top-up a minimum value of $5 using PayNow.</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
        theme={undefined}
        sx={{ borderRadius: '8px', overflow: 'hidden',mb:1 }}
      >
        <AccordionSummary
          expandIcon={<KeyboardArrowRightIcon style={{ color: colorConfigs.secondary }} />}
          aria-controls="panel2d-content"
          id="panel2d-header"
        >
          <Typography sx={{ ...typo.bodyContent, color: colorConfigs.secondary }}>
            Will there be additional fees incurred for credit card linkage?
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          theme={undefined}
          expanded={false}
          sx={{
            background:colorConfigs.quaternary,
            borderRadius: '0 0 8px 8px',
            boxShadow: 1,
            borderStyle:'solid',
            borderWidth:2,
            borderTop: 'none',
          }}
        >
          <Typography sx={typo.bodyContent}>
            There will be a pre-authorization charge of $0.01 that will be credited to your wallet. Subsequent purchases will automatically be deducted from the linked credit card.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === 'panel3'}
        onChange={handleChange('panel3')}
        theme={undefined}
        sx={{ borderRadius: '8px', overflow: 'hidden',mb:1 }}
      >
        <AccordionSummary
          expandIcon={<KeyboardArrowRightIcon style={{ color: colorConfigs.secondary }} />}
          aria-controls="panel3d-content"
          id="panel3d-header"
        >
          <Typography sx={{ ...typo.bodyContent, color: colorConfigs.secondary }}>How to unlock the fridge?</Typography>
        </AccordionSummary>
        <AccordionDetails
          theme={undefined}
          expanded={false}
          sx={{
            background:colorConfigs.quaternary,
            borderRadius: '0 0 8px 8px',
            boxShadow: 1,
            borderStyle:'solid',
            borderWidth:2,
            borderTop: 'none',
          }}
        >
          <Typography sx={typo.bodyContent}>Place the QR code displayed in your wallet against the scanner. Just a friendly reminder that you'll need to link your credit card, or have a min. balance of $5 in your wallet before you can unlock it!</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === 'panel4'}
        onChange={handleChange('panel4')}
        theme={undefined}
        sx={{ borderRadius: '8px', overflow: 'hidden',mb:1}}
      >
        <AccordionSummary
          expandIcon={<KeyboardArrowRightIcon style={{ color: colorConfigs.secondary }} />}
          aria-controls="panel4d-content"
          id="panel4d-header"
        >
          <Typography sx={{ ...typo.bodyContent, color: colorConfigs.secondary }}>How do I add products to my cart?</Typography>
        </AccordionSummary>
        <AccordionDetails
          theme={undefined}
          expanded={false}
          sx={{
            background:colorConfigs.quaternary,
            borderRadius: '0 0 8px 8px',
            boxShadow: 1,
            borderStyle:'solid',
            borderWidth:2,
            borderTop: 'none',
          }}
        >
          <Typography sx={typo.bodyContent}>Scan each item's barcode against the scanner of the smart fridge!</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === 'panel5'}
        onChange={handleChange('panel5')}
        theme={undefined}
        sx={{ borderRadius: '8px', overflow: 'hidden',mb:1 }}
      >
        <AccordionSummary
          expandIcon={<KeyboardArrowRightIcon style={{ color: colorConfigs.secondary }} />}
          aria-controls="panel5d-content"
          id="panel5d-header"
        >
          <Typography sx={{ ...typo.bodyContent, color: colorConfigs.secondary }}>I'm done adding products to cart. How do I pay?</Typography>
        </AccordionSummary>
        <AccordionDetails
          theme={undefined}
          expanded={false}
          sx={{
            background:colorConfigs.quaternary,
            borderRadius: '0 0 8px 8px',
            boxShadow: 1,
            borderStyle:'solid',
            borderWidth:2,
            borderTop: 'none',
          }}
        >
          <Typography sx={typo.bodyContent}>Pay using your linked credit card, or your wallet balance! </Typography>
        </AccordionDetails>
      </Accordion>
      <Typography variant="h6" sx={{ ...typo.title, mb: 2, mt: 1 }}>
        Support
      </Typography>
      <Accordion
        expanded={expanded === 'panel6'}
        onChange={handleChange('panel6')}
        theme={undefined}
        sx={{ borderRadius: '8px', overflow: 'hidden',mb:1 }}
      >
        <AccordionSummary
          expandIcon={<KeyboardArrowRightIcon style={{ color: colorConfigs.secondary }} />}
          aria-controls="panel6d-content"
          id="panel6d-header"
        >
          <Typography sx={{ ...typo.bodyContent, color: colorConfigs.secondary }}>How do I report an issue or provide feedback?</Typography>
        </AccordionSummary>
        <AccordionDetails
          theme={undefined}
          expanded={false}
          sx={{
            background:colorConfigs.quaternary,
            borderRadius: '0 0 8px 8px',
            boxShadow: 1,
            borderStyle:'solid',
            borderWidth:2,
            borderTop: 'none',
          }}
        >
          <Typography sx={typo.bodyContent}>
            We suggest writing in to <b>hello@nomzy.club</b>, and we'll get back to you within 3 business days! You can also reach us via WhatsApp, or call us at 3129 8094. Our team is available on weekdays from 9am-9pm.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>

  );
}
